import React from "react";
import styles from "./Dialog.module.scss";
import classNames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import Button from "../Button/Button";
import CerrarImg from "../../../assets/img/icons/x-blue.svg";
import DialogImg from "../../../assets/img/icons/alert-triangle.svg";
import UploadImg from "../../../assets/img/icons/upload.svg";
import CheckCircleImg from "../../../assets/img/icons/check-circle.svg";

export interface DialogProps {
  id?: string;
  bodyCssClassName?: string;
  cancelBtnText?: string;
  confirmBtnText?: string;
  icon: string;
  disableCancel?: boolean;
  disableConfirm?: boolean;
  footerCssClassName?: string;
  headerCssClassName?: string;
  loader?: boolean;
  onCancel: React.MouseEventHandler<any>;
  onConfirm?: React.MouseEventHandler<any>;
  showCancel?: boolean;
  showConfirm?: boolean;
  title?: string;
}

/* Alert properties can be found here:
 * https://github.com/djorg83/react-bootstrap-sweetalert
 */
class Dialog extends React.Component<DialogProps> {

  getIcon(){
    switch(this.props.icon){
    case "upload":
      return UploadImg;
      break;
    case "alert-triangle":
      return DialogImg;
      break;
    case "check-circle":
      return CheckCircleImg;
      break;
    }
  }

  showCancel = true;
  showConfirm = true;

  render() {

    this.showCancel = this.props.showCancel !== false;
    this.showConfirm = this.props.showConfirm !== false;

    return (
      <SweetAlert showConfirm={false}
                  showCancel={false}
                  onConfirm={(object) => object===undefined}
                  title={""}
                  customClass={styles.Dialog}
                  id={this.props.id}>

        <div className={classNames(styles.Header, this.props.headerCssClassName)}>

          <div className={styles.Icon}>
            <img id="dDialogIconImg"
                 src={this.getIcon()}
                 alt={"Dialogo"}/>
          </div>

          <div className={styles.Title}>{this.props.title}</div>

          <div className={styles.Close}>
            <img id="dCloseIconImg"
                 src={CerrarImg}
                 onClick={this.props.onCancel}
                 alt={"Cerrar"}/>
          </div>

        </div>

        <div id={this.props.id} className={classNames(styles.Body, this.props.bodyCssClassName)}>
        {this.props.children}</div>

        <div className={classNames(styles.Footer, this.props.footerCssClassName)}>

          {(this.showCancel && this.props.cancelBtnText) &&
          <Button
            id="dCancelarBtn"
            name="dCancelarBtn"
            type="button"
            typeStyle="ghost"
            onClick={this.props.onCancel}
            cssClassName={styles.Button}
            disabled={this.props.disableCancel}
            loader={this.props.loader}>
            {this.props.cancelBtnText}
          </Button>
          }

          {(this.showConfirm && this.props.confirmBtnText) &&
          <Button
            id="dConfirmarBtn"
            name="dConfirmarBtn"
            type="button"
            typeStyle="primary"
            onClick={this.props.onConfirm}
            cssClassName={styles.Button}
            disabled={this.props.disableConfirm || this.props.loader}
            loader={this.props.loader}>
            {this.props.confirmBtnText}
          </Button>
          }

        </div>

      </SweetAlert>
    );
  }
}

export default Dialog;
